import { useSelector } from 'react-redux'
import type { Constant } from '@pbt/pbt-ui-components'

import CheckboxListFilter, {
  type CheckboxListFilterProps,
} from '~/components/common/filters/CheckboxListFilter'
import PracticeStatusLabel from '~/components/common/PracticeStatusLabel'
import { getBusinessStatus } from '~/store/reducers/constants'

export interface PracticesStatusFilterProps extends CheckboxListFilterProps {}

const PracticesStatusFilter = (props: PracticesStatusFilterProps) => {
  const BusinessStatus: Constant[] = useSelector(getBusinessStatus)
  const filterStatusItems = BusinessStatus.map((item) => ({
    ...item,
    component: <PracticeStatusLabel statusId={item.id} variant="big" />,
  }))

  return <CheckboxListFilter items={filterStatusItems} {...props} />
}

export default PracticesStatusFilter
